import { ShieldCheck, Star, Zap } from "lucide-react";

/**
 * Renders trust badges for a seller.
 * Props:
 *  - badges: string[] like ["verified", "trusted", "top"]
 *  - size: "sm" | "md"
 */
export default function TrustBadge({ badges = [], size = "sm" }) {
  if (!badges || badges.length === 0) return null;
  const cfg = {
    verified: { icon: ShieldCheck, label: "VERIFIED", cls: "bg-black text-[#D4FF00]" },
    trusted:  { icon: Star,        label: "TRUSTED",  cls: "bg-[#D4FF00] text-black" },
    top:      { icon: Zap,         label: "TOP",      cls: "bg-[#FF007F] text-white" },
  };
  const pad = size === "md" ? "px-2 py-[3px] text-[11px]" : "px-1.5 py-[1px] text-[9px]";
  return (
    <div className="flex gap-1 flex-wrap" data-testid="trust-badges">
      {badges.map((b) => {
        const c = cfg[b];
        if (!c) return null;
        const Icon = c.icon;
        return (
          <span
            key={b}
            data-testid={`badge-${b}`}
            className={`inline-flex items-center gap-1 border-2 border-black font-mono-b font-bold uppercase tracking-wide ${pad} ${c.cls}`}
          >
            <Icon className={`${size === "md" ? "w-3 h-3" : "w-2.5 h-2.5"}`} />
            {c.label}
          </span>
        );
      })}
    </div>
  );
}
